export const API_ORGANIZATION_ID = import.meta.env.VITE_API_ORGANIZATION_ID;
export const TIMEZONE = import.meta.env.VITE_TIMEZONE;
